export enum Language {
    English = 'EN',
    French = 'FR',
    German = 'DE',
    Dutch = 'NL',
}
